import { useQuery, QueryFunction } from 'react-query';
import {
    getActiveTools,
    getAllTools,
    GetMonthlyToolParams,
    getMonthlyTools,
    GetToolsQueries,
    getToolWithLastLocation,
    MonthlyTool,
    Tool,
    ToolWithLastLocation,
} from '../../services/apiSLTP/materials/tools';

type UseToolsQueryOptions = {
    queries?: GetToolsQueries;
};

const getTools: QueryFunction<Tool[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseToolsQueryOptions];
    const { queries } = options;

    const response = await getAllTools(queries);
    return response.data;
};

export const useToolsQuery = (options: UseToolsQueryOptions) => {
    return useQuery(['tools', options], getTools);
};

type UseActiveToolsQueryOptions = {};

const getAllActiveTools: QueryFunction<Tool[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseActiveToolsQueryOptions];
    const {} = options;

    const response = await getActiveTools();
    return response.data;
};

export const useActiveToolsQuery = (options: UseActiveToolsQueryOptions) => {
    return useQuery(['activeTools', options], getAllActiveTools);
};

type UseToolsWithLastLocationQueryOptions = {
    date: Date;
};

const getToolsLastLocations: QueryFunction<ToolWithLastLocation[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseToolsWithLastLocationQueryOptions];
    const { date } = options;

    const response = await getToolWithLastLocation(date);
    return response.data;
};

export const useToolsWithLastLocationsQuery = (options: UseToolsWithLastLocationQueryOptions) => {
    return useQuery(['tools locations', options], getToolsLastLocations);
};


type UseMonthlyToolsQueryOptions = {
    params: GetMonthlyToolParams;
};

const getMonthlyToolsQuery: QueryFunction<MonthlyTool[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlyToolsQueryOptions];
    const { params } = options;

    const response = await getMonthlyTools(params);
    return response.data;
};

export const useMonthlyToolsQuery = (options: UseMonthlyToolsQueryOptions) => {
    return useQuery(['monthly tools', options], getMonthlyToolsQuery);
};